import { EntityTypeId } from "../../../../core/entity/EntityTypeId.enum"
import type { Entity } from "../../../../core/entity/index"

const neverGrassEntityTypeIdList = [
  EntityTypeId.Forest,
  EntityTypeId.Jungle,
  EntityTypeId.Mountain,
  EntityTypeId.Deadwood,
  EntityTypeId.Road,
  EntityTypeId.Building,
  EntityTypeId.HQ,
  EntityTypeId.Factory,
]

export default function isEntityNeverGrassWaves(ent: Entity) {
  return neverGrassEntityTypeIdList.includes(ent.etype_id)
}
